module.exports = {
	"classes": [
		"dpa-editable-page",
		"header-dark"
	],
	"title": "Data Processing Addendum (DPA)",
	"metas": {
		"description": "This page provides an editable version of Auth0's DPA, for use by Auth0 prospects and customers who are subject to the European Union's General Data Protection Regulation (GDPR)."
	},
	"opengraph": {
		"og:title": "Data Processing Addendum (DPA)",
		"og:description": "This page provides an editable version of Auth0's DPA, for use by Auth0 prospects and customers who are subject to the European Union's General Data Protection Regulation (GDPR).",
		"og:url": "https://auth0.com/legal/baseline/dpa/edit"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa-editable/metadata.json
// module id = 1408
// module chunks = 0